'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    if (Object.keys(data).length === 0) return;
    var ul = document.createElement('ul');
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        ul.append(li);
        createTree(li, data[key]);
    }
    element.append(ul);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.540a9f01.js.map
